import { Route } from "@angular/router";
import { initialDataResolver } from "app/app.resolvers";
import { AuthGuard } from "app/core/auth/guards/auth.guard";
import { NoAuthGuard } from "app/core/auth/guards/noAuth.guard";
import { SuperAdminGuard } from "app/core/auth/guards/super-admin.guard";
import { LayoutComponent } from "app/layout/layout.component";

export const appRoutes: Route[] = [
  { path: "", pathMatch: "full", redirectTo: "reservations" },

  { path: "signed-in-redirect", pathMatch: "full", redirectTo: "reservations" },

  {
    path: "",
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "confirmation-required",
        loadChildren: () =>
          import(
            "app/modules/auth/confirmation-required/confirmation-required.routes"
          ),
      },
      {
        path: "forgot-password",
        loadChildren: () =>
          import("app/modules/auth/forgot-password/forgot-password.routes"),
      },
      {
        path: "otp-verification",
        loadChildren: () =>
          import("app/modules/auth/otp-verification/otp-verification.routes"),
      },
      {
        path: "reset-password",
        loadChildren: () =>
          import("app/modules/auth/reset-password/reset-password.routes"),
      },
      {
        path: "sign-in",
        loadChildren: () => import("app/modules/auth/sign-in/sign-in.routes"),
      },
      {
        path: "sign-up",
        loadChildren: () => import("app/modules/auth/sign-up/sign-up.routes"),
      },
    ],
  },

  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "sign-out",
        loadChildren: () => import("app/modules/auth/sign-out/sign-out.routes"),
      },
      {
        path: "unlock-session",
        loadChildren: () =>
          import("app/modules/auth/unlock-session/unlock-session.routes"),
      },
    ],
  },

  {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "home",
        loadChildren: () => import("app/modules/landing/home/home.routes"),
      },
    ],
  },

  {
    path: "r",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: ":slug",
        loadChildren: () =>
          import("app/modules/public/booking/booking.routes").then(
            (m) => m.bookingRoutes
          ),
      },
    ],
  },

  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("app/modules/admin/pages/dashboard/dashboard.routes"),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("app/modules/admin/pages/settings/settings.routes"),
      },
      {
        path: "reservations",
        loadChildren: () =>
          import("app/modules/admin/pages/reservation/reservation.routes"),
      },
      {
        path: "report",
        loadChildren: () =>
          import("app/modules/admin/pages/report/report.routes"),
      },
      {
        path: "ayuda",
        loadChildren: () => import("app/modules/admin/pages/help/help.routes"),
      },
      {
        path: "faqs",
        loadChildren: () => import("app/modules/admin/pages/faq/faqs.routes"),
      },
      {
        path: "platform",
        canActivate: [SuperAdminGuard],
        loadChildren: () =>
          import("app/modules/admin/pages/platform/platform.routes"),
      },
    ],
  },
];
